import css from './AdminContent.module.css';

import AdminCard from '../AdminCard/AdminCard';
import APIManagement from '../APIManagement/APIManagement';
import Configuration from '../Configuration/Configuration';
import LogViewer from '../LogViewer/LogViewer';
import UserManagement from '../UserManagement/UserManagement';
import UserApproval from '../UserApproval/UserApproval';
import PendingCreation from '../PendingCreation/PendingCreation';

type AdminContentProps = {
  selectedKey: string;
};

const contentMap: Map<string, JSX.Element> = new Map();
contentMap.set('0-1', <UserManagement />);
contentMap.set('0-2', <APIManagement />);
contentMap.set('0-3', <UserApproval />);
contentMap.set('0-4', <PendingCreation />);
contentMap.set('1', <LogViewer />);
contentMap.set('2', <Configuration />);

const AdminContent = ({ selectedKey }: AdminContentProps) => {
  const isTableContent = ['0-1', '0-2', '0-3', '0-4', '1'].includes(selectedKey);
  
  return (
    <AdminCard 
      flexDirection='column' 
      secondaryClass={css.adminCard}
      noPadding={isTableContent}
      noBorder={true}
      noShadow={true}
    >
      {contentMap.get(selectedKey)}
    </AdminCard>
  );
};

export default AdminContent;